let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9co09")).then(() => parcelRequire('1NtAt'));